import request from "@/api";

export function listGoods(data) {
    return request({
        url: '/api/goods/getGoodsList',
        method: 'get',
        params: data
    })
}

export function getGoodsInfo(data) {
    return request({
        url: '/api/goods/getGoodsInfo',
        method: 'get',
        params: data
    })
}

export function saveGoods(data) {
    return request({
        url: '/api/goods/saveGoods',
        method: 'post',
        data: data
    })
}

export function updateGoods(data) {
    return request({
        url: '/api/goods/updateGoods',
        method: 'post',
        data: data
    })
}

export function deleteGoods(data) {
    return request({
        url: '/api/goods/deleteGoods',
        method: 'post',
        data: data
    })
}

export function exportGoods(data) {
    return request({
        url: '/api/goods/export',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function batchSaveGoodsRemoveRecover(data) {
    return request({
        url: '/api/goods/batchSaveGoodsRemoveRecover',
        method: 'post',
        data: data
    })
}